import { Tool } from "@/data/tools";

/**
 * Returns a list of featured tools that changes every 48 hours.
 * selection is randomized but deterministic for the same 48-hour window.
 */
export function getFeaturedTools(tools: Tool[], count: number = 15): Tool[] {
    // 48 hours in milliseconds
    const EPOCH_LENGTH = 48 * 60 * 60 * 1000;

    // Calculate the current epoch seed
    // This integer will be the same for any timestamp within the same 48h block
    const seed = Math.floor(Date.now() / EPOCH_LENGTH);

    // Create a copy of the array to shuffle
    const shuffled = [...tools];

    // Fisher-Yates shuffle using a seeded random generator
    // We use a simple Linear Congruential Generator (LCG) for deterministic randomness
    let currentSeed = seed;
    const nextRandom = () => {
        // LCG parameters (glibc values)
        const m = 2147483648; // 2^31
        const a = 1103515245;
        const c = 12345;
        currentSeed = (a * currentSeed + c) % m;
        return currentSeed / m;
    };

    for (let i = shuffled.length - 1; i > 0; i--) {
        const j = Math.floor(nextRandom() * (i + 1));
        [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
    }

    return shuffled.slice(0, count);
}
